import {
  ChangeEvent,
  DragEvent,
  MouseEvent,
  useCallback,
  useRef,
  useState
} from 'react';

import { EToasterStatus, showToast } from '../../../../utils/showToast';

export const useUploadContent = (
  setValue: (
    fieldName: any,
    file: File | null,
    p: { shouldValidate: boolean }
  ) => void
) => {
  const [isDragging, setIsDragging] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const fileSrcRef = useRef<string | null>(null);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setValue('image', file, { shouldValidate: true });
    fileSrcRef.current = URL.createObjectURL(file);
  };

  const handleDragOver = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const onDrop = useCallback(
    (e: DragEvent<HTMLDivElement>) => {
      e.preventDefault();
      setIsDragging(false);
      const file = e.dataTransfer.files[0];
      if (!file) return;
      if (file.size > 2000000) {
        showToast({
          message: 'File size limit is 2MB',
          status: EToasterStatus.ERROR
        });
        return;
      }
      fileSrcRef.current = URL.createObjectURL(file);
      setValue('image', file, { shouldValidate: true });
    },
    [setValue]
  );

  const handleButtonClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    inputRef.current?.click();
  };

  return {
    isDragging,
    handleInputChange,
    handleDragOver,
    handleDragLeave,
    onDrop,
    handleButtonClick,
    fileSrcRef,
    inputRef
  };
};
